import { Component } from '@angular/core';
import { DwComponent, DwComponentType, DwFilterTileRendererBaseComponent, DwMetaDataFilterTileState } from '@devwareapps/devware-cap';

/** Maps the legacy tile heading classes configured in the DB to pill dot colors. */
const DOT_CLASSES: { [headingClass: string]: string } = {
  'dw-green-bg': 'qbt-dot--green',
  'dw-orange-bg': 'qbt-dot--orange',
  'dw-blue-bg': 'qbt-dot--blue',
  'dw-gray-bg': 'qbt-dot--gray',
  'dw-red-bg': 'qbt-dot--red'
};

@DwComponent({
  key: 'question-bank-filter-tile-renderer',
  name: 'Question Bank Filter Tile Renderer (pills)',
  isGlobal: true,
  componentType: DwComponentType.filterTileRenderer
})
@Component({
  selector: 'app-question-bank-filter-tiles',
  templateUrl: './question-bank-filter-tiles.component.html',
  styleUrls: ['./question-bank-filter-tiles.component.scss']
})
export class QuestionBankFilterTilesComponent extends DwFilterTileRendererBaseComponent {

  dotClass(tile: DwMetaDataFilterTileState): string {
    const config: any = tile?.filterTileConfig || {};
    return DOT_CLASSES[config.tileHeadingClass] || DOT_CLASSES[`dw-${config.tileHeaderBackgroundColor}-bg`] || 'qbt-dot--gray';
  }

  trackByTile(index: number, tile: DwMetaDataFilterTileState): string {
    return tile?.filterTileConfig?.tileKey || String(index);
  }
}
